export const scheduleSelector = (state) => state.schedule.schedule;
export const resourcesSelector = (state) => state.schedule.resources;
export const eventsSelector = (state) => state.schedule.events;
export const isLoadingSelector = (state) => state.schedule.loading;
export const shiftSelector = (state) => state.schedule.shift;
export const markersSelector = (state) => state.schedule.markers;
export const postShiftIsLoadingSelector = (state) => state.schedule.postShiftLoading;
